const ServerPath = {
    globalImage: 'GLOBAL_IMAGE',
    globalCss: 'GLOBAL_CSS',
    globalScript: 'GLOBAL_SCRIPT',
    siteImage: 'SITE_IMAGE',
    siteCss: 'SITE_CSS',
    siteHtml: 'SITE_HTML',
    helpUiHtml: 'HELP_UI_HTML',
    helpUiHtmlGlobal: 'HELP_UI_HTML_GLOBAL',
    helpUiGlobal: 'HELP_UI_CSS_GLOBAL',
    helpUiTheme: 'HELP_UI_THEME',
    landingPage: 'LANDING_PAGE',
    colorscheme: 'COLOR_SCHEME',
    autoColorscheme: 'AUTO_COLOR_SCHEME'
};

export default ServerPath;
